export default "__VITE_ASSET__95d73b84__"